import * as React from "./exports";

export * from "./exports";

export default React;
